import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "blog-card" }
const _hoisted_2 = { class: "card-banner" }
const _hoisted_3 = {
  class: "card-title",
  style: {"font-size":"22px","text-align":"center"}
}
const _hoisted_4 = { href: "#" }

import Work from "@/models/Work";
import CWorkPreview from "@/components/my-works/CWorkPreview.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CWorkCard',
  props: {
  work: {
    type: Work,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("figure", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: 'works.detail', params: { id: __props.work.name } }
      }, {
        default: _withCtx(() => [
          _createVNode(CWorkPreview, { work: __props.work }, null, 8, ["work"])
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("h3", _hoisted_3, [
      _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t(`portfolio.${__props.work.name}.name`)), 1)
    ])
  ]))
}
}

})